import { useToast } from "@chakra-ui/react";
import { showErrorToast, showSuccessToast } from "../util/errorHandler";
import { broadcastRecordChange } from "./useRecordSync";

export const useVisibilityToggle = (setRecords, updateVisibilityFn, entity) => {
  const toast = useToast();

  const handleToggleVisible = async (record, newValue) => {
    const alias = record?.alias || record?._id || record?.id;
    setRecords((prev) =>
      prev.map((r) =>
        (r.alias || r._id || r.id) === alias ? { ...r, isVisible: newValue } : r
      )
    );
    try {
      await updateVisibilityFn(alias, newValue);
      // Tell other tabs the card's visible/hidden state changed.
      if (entity) {
        broadcastRecordChange(entity, {
          id: alias,
          action: "visibility",
          snapshot: { isVisible: newValue },
        });
      }
      showSuccessToast(toast, `Is Visible set to ${newValue ? "Yes" : "No"}`, "top-right");
    } catch (error) {
      setRecords((prev) =>
        prev.map((r) =>
          (r.alias || r._id || r.id) === alias ? { ...r, isVisible: !newValue } : r
        )
      );
      showErrorToast(toast, "Failed to update visibility", "top-right");
    }
  };

  return handleToggleVisible;
};
